module.exports = __webpack_public_path__ + "img/prayer-journal_B095GRWLVL.dae962d7.jpg";